// Vibrant Light Theme - Color System
// Based on VIBRANT_LIGHT_THEME_SPECIFICATION.md

export const colors = {
  // Primary Colors
  primary: {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1565c0',
  },

  // Secondary Colors
  secondary: {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    main: '#009688',
    light: '#4db6ac',
    dark: '#00695c',
  },

  // Semantic Colors
  success: {
    light: '#81c784',
    main: '#4caf50',
    dark: '#388e3c',
    container: '#e8f5e9',
    onContainer: '#1b5e20',
  },

  warning: {
    light: '#ffb74d',
    main: '#ff9800',
    dark: '#f57c00',
    container: '#fff3e0',
    onContainer: '#e65100',
  },

  error: {
    light: '#e57373',
    main: '#f44336',
    dark: '#d32f2f',
    container: '#ffebee',
    onContainer: '#b71c1c',
  },

  info: {
    light: '#64b5f6',
    main: '#2196f3',
    dark: '#1976d2',
    container: '#e3f2fd',
    onContainer: '#0d47a1',
  },

  // Background Colors
  background: {
    default: '#fafafa',
    paper: '#ffffff',
    elevated: '#ffffff',
  },

  // Surface Colors
  surface: {
    containerLowest: '#ffffff',
    containerLow: '#f5f5f5',
    container: '#f0f0f0',
    containerHigh: '#ebebeb',
    containerHighest: '#e0e0e0',
  },

  // Sidebar Colors
  sidebar: {
    background: '#1e293b',
    hover: '#334155',
    active: '#475569',
  },

  // Text Colors
  text: {
    primary: '#212121',
    secondary: '#757575',
    disabled: '#bdbdbd',
    hint: '#9e9e9e',
  },

  // Text on Dark Backgrounds
  textOnDark: {
    primary: '#ffffff',
    secondary: '#cbd5e1',
    disabled: '#94a3b8',
  },

  // Outline Colors
  outline: {
    main: '#e0e0e0',
    variant: '#f0f0f0',
  },
}

export default colors
